<template>
  <router-view />
</template>

<script>
import url from "@/plugins/urlHelper.js";

import user from "@/plugins/user.js";
export default {
  data() {
    return {};
  },
  created() {
    //跳转登录
    var _this = this;
    // _this.$router.push('login');

    //跳转定义
    window.winOpen = function(url, btn) {
      _this.$router.push(url);
      $(btn)
        .parents(".el-notification")
        .hide("slow");
    };
  }
};
</script>